import {
  Property,
  PropertyResponse,
  PropertyValue,
  PropertyValueResponse,
  ValueAttributeCell,
  ValueAttributeCellResponse,
} from "./pl-properties.types";

// Converts a PropertyResponse → Property (and related helpers)

// --- Helpers --------------------------------------------------------------

function idsFrom<T extends { id?: string }>(
  items: T[] | undefined | null
): string[] {
  if (!items?.length) return [];

  // Keep order, drop empties
  return items.map((i) => i.id).filter((x): x is string => !!x);
}

// --- Converters -----------------------------------------------------------

export function ValueAttributeCellResponseToValueAttributeCell(
  cell: ValueAttributeCellResponse
): ValueAttributeCell {
  const vac: ValueAttributeCell = {
    propertyValueAttributeId: cell.propertyValueAttribute?.id ?? "",
    value: cell.value ?? "",
  };
  return vac;
}

export function PropertyValueResponseToPropertyValue(
  propertyValueResponse: PropertyValueResponse
): PropertyValue {
  const propVal: PropertyValue = {
    id: propertyValueResponse.id,
    valueAttributeCells: (propertyValueResponse.valueAttributeCells ?? []).map(
      (cell) => ValueAttributeCellResponseToValueAttributeCell(cell)
    ),
  };

  return propVal;
}

export function PropertyResponseToProperty(src: PropertyResponse): Property {
  return {
    id: src.id,
    productlineId: src.productLineId, // note: productLineId → productlineId
    parentId: src.parentId ?? null,
    name: src.name,
    dataType: src.dataType,
    domain: src.domain,
    default: src.default ?? null,
    rulesetIds: idsFrom(src.ruleSets),
    tagIds: idsFrom(src.tags),
    propertyValueAttributeIds: idsFrom(src.propertyValueAttributes),
    propertyValues: (src.propertyValues ?? []).map((pv) =>
      PropertyValueResponseToPropertyValue(pv)
    ),
    comments: src.comments ?? "",
    sources: src.sources ?? "",
    autoSelection: !!src.autoSelection,
    ownerTool: src.ownerTool ?? "",
    dbSchemaVersion: src.dbSchemaVersion,
  };
}

// --- Bulk Convert ------------------------------------

export function toProperties(src: PropertyResponse[]): Property[] {
  return (src ?? []).map(PropertyResponseToProperty);
}
